export class Quota {
    value: number;
    max: number;

    constructor(max: number) {
        this.value = 0;
        this.max = max;
    }
}
